import { combineReducers } from 'redux'

import user from 'reducers/User'

export default combineReducers({
  user
})
